import { useMemo } from 'react';
import { InputRuleApiModel } from '~/lib/api/smartsend/types';
import { HideableConsignmentContentsFields } from './consignments/ConsignmentSummaryParcels';

export const useHiddenRowFields = (productValidation?: InputRuleApiModel[]) => {
  const hiddenRowFields = useMemo(() => {
    if (!productValidation) {
      return [];
    }
    const output: string[] = [];
    HideableConsignmentContentsFields.forEach((f) => {
      if (!productValidation.some((x) => x.name === f)) {
        output.push(f);
      }
    });
    return output;
  }, [productValidation]);
  return hiddenRowFields;
};
